import { ENV_ECLIPSE, ENV_VSCODE, ENV_WEB } from "./constants";
import { writeFileApi as writeFile, readFile } from "../../api/uvm";

// import { JS2JAVA_readFile, JS2JAVA_writeFile } from './eclipse';
import M100_144 from '@/store/bosc/mcu/M100_144.json';
import gpio from '@/store/bosc/mcu/GPIO_BOSC1xx.json';
import usart from '@/store/bosc/mcu/USART_BOSC1xx.json';
import spi from '@/store/bosc/mcu/SPI_BOSC1xx.json';

export async function writeUserChip(state) {
    const content = JSON.stringify(state.chip);
    console.log('%state.enviroment=' + state.enviroment)
    switch (state.enviroment) {
        case ENV_ECLIPSE:
            try {
                const result = JS2JAVA_writeFile(state.projectPath + '/.pinout', content);
                // alert(result)
            } catch (e) {
                alert(e.message);
            }
            break;
        case ENV_WEB:

            writeFile({
                path: 'pinout.json',
                editingFile: content
            });
            break;
        case ENV_VSCODE:


            break;
        default:
            break;
    }
}

export async function readUserChip(state) {
    let content = undefined;
    console.log('#state.enviroment=' + state.enviroment)
    switch (state.enviroment) {
        case ENV_ECLIPSE:
            try {
                content = JS2JAVA_readFile(state.projectPath + '/.pinout');
                // alert(`content=${content}`)
                if (content.startsWith('ERRMSG:')) {
                    content = null;
                }
            } catch (e) {
                alert(e.message);
            }
            break;
        case ENV_WEB:

            // content = await readFile({ filePath: 'pinout.json' });
            
            break;
        case ENV_VSCODE:

            break;
        default:
            break;
    }

    if (content) {
        return JSON.parse(content);
    }
}

export async function readConfigFile(state, configName) {

    if (configName === 'M100_144') {
        return M100_144;
    } else if (configName === 'GPIO_BOSC1xx') {
        return gpio
    } else if (configName === 'USART_BOSC1xx') {
        return usart
    } else if (configName === 'SPI_BOSC1xx') {
        return spi
    }
    

    const filePath = 'bosc/mcu' + configName + '.json';
    let content = undefined;
    console.log('@state.enviroment=' + state.enviroment)
    switch (state.enviroment) {
        case ENV_ECLIPSE:
            try {
                content = JS2JAVA_readFile(state.toolPath + '/' + filePath);
            } catch (e) {
                alert(e.message);
            }
            break;
        case ENV_WEB:

            const res = await readFile({filePath: filePath})
            if (res.code === 200) {
                content = res.data;
            }
            break;
        case ENV_VSCODE:


            break;
        default:
            break;
    }

    if (content) {
        return JSON.parse(content);
    }
}

export async function writeSourceFile(state, fileName, content) {
    console.log('state.enviroment=' + state.enviroment)
    switch (state.enviroment) {
        case ENV_ECLIPSE:
            try {
                const result = JS2JAVA_writeFile(state.projectPath + '/src/' + fileName + '.c', content);
                // alert(result)
            } catch (e) {
                alert(e.message);
            }
            break;
        case ENV_WEB:
        
            writeFile({
                path: 'application/' + fileName + '.c',
                editingFile: content
            });
            break;
        case ENV_VSCODE:


            break;
        default:
            break;
    }
}